module.exports = __webpack_public_path__ + "static/media/calendario icon.a111e773.svg";